import axios from 'axios'
import Vue from 'vue'

let vm = new Vue()
const errorHandle = (status, msg, response) => {
	console.log(response)
	switch (status) {
		case 400:
			break;
		case 401:
			break;
		case 404:
			break;
		case 500:
			break;
		case 502:
			break;
		default:
			console.log('攔不到錯誤QQ')
	}
}

// https://httpstat.us/ 用來測各種status code的網站
let instance = axios.create({
	baseURL: process.env.VUE_APP_API_ENDPOINT,
})

instance.interceptors.request.use(
	(config) => {
		let admin_session = localStorage.getItem('admin_session')
		let token = 'Bearer reservation_admin.reservation_admin1805'
		if (admin_session !== null && admin_session !== 'null'){
			admin_session = JSON.parse(admin_session)
			token += '.' + admin_session.user_id + '.' + admin_session.token			
		}
		else {
			token += '..'
		}
		// console.log(config)
		// config.baseURL = 'https://httpstat.us/'
		// config.url = '500'
		config.headers.Authorization = token;
		// console.log(config)
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

instance.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		const { response } = error;

		if (response) {
			errorHandle(response.status, response.data.error, response);
		}

		return Promise.reject(error);
	}
);

export default function(method, url, data=null) {
	method = method.toLowerCase();

	switch (method) {
		case 'get':
			return instance.get(url, {params: data})

		case 'post':
			return instance.post(url, data)

		case 'put':
			return instance.put(url, data)

		case 'delete':
			return instance.delete(url, {params: data})

		default:
			console.error('unknown_request_method' + method)
			return false
	}
}
